import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import processingStepsService from '../services/processingStepsService';
import StepSettingsEditor from './shared/StepSettingsEditor';
import './ConnectorForm.css';

function ProcessingStepsForm({ mode = 'create' }) {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = mode === 'edit';

    const [formData, setFormData] = useState({ name: '', description: '' });
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isEdit && id) {
            setLoading(true);
            processingStepsService.getById(id)
                .then(data => setFormData({ name: data.name || '', description: data.description || '' }))
                .catch(err => setError(err.response?.data?.message || err.message || 'Failed to load'))
                .finally(() => setLoading(false));
        }
    }, [id, isEdit]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) { setError('Name is required'); return; }
        setSaving(true);
        setError(null);
        try {
            if (isEdit) {
                await processingStepsService.update(id, formData);
            } else {
                await processingStepsService.create(formData);
            }
            navigate('/admin/sync-processing-steps');
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Save failed');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="connector-form-container"><p>Loading…</p></div>;

    return (
        <div className="connector-form-container">
            <div className="connector-form-header">
                <h1>{isEdit ? 'Edit Processing Step' : 'New Processing Step'}</h1>
            </div>

            {error && <div className="connector-form-error">{error}</div>}

            <form onSubmit={handleSubmit} className="connector-form">
                <div className="form-section">
                    <div className="form-group">
                        <label htmlFor="name">Name <span className="required">*</span></label>
                        <input id="name" name="name" type="text" value={formData.name} onChange={handleChange}
                            className="form-control" placeholder="Step name" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <textarea id="description" name="description" value={formData.description} onChange={handleChange}
                            className="form-control" rows={3} placeholder="Optional description" />
                    </div>
                </div>

                <div className="form-actions">
                    <button type="button" className="btn-secondary" onClick={() => navigate('/admin/sync-processing-steps')}>
                        Cancel
                    </button>
                    <button type="submit" className="btn-primary" disabled={saving}>
                        {saving ? 'Saving…' : (isEdit ? 'Save Changes' : 'Create Step')}
                    </button>
                </div>
            </form>

            {isEdit && <StepSettingsEditor stepId={id} />}
        </div>
    );
}

export default ProcessingStepsForm;
